import role from './config.role';

const authority = {
  Home: [role.admin, role.editor, role.developer],
  Ontology: [role.admin, role.editor, role.developer],
  Json: [role.admin, role.editor, role.developer],
  Markdown: [role.admin, role.editor, role.reader, role.developer, role.anonymous],
  Sparql: [role.admin, role.editor, role.developer],
  Crypto: [role.admin, role.editor, role.developer],
  Authority: [role.admin],
};

export default authority;
